import Content from '../../../../components/Section/Content';
import Box from '../../../../components/Section/Box';
import Icon from '../../../../components/Section/Icon';
import svg from '../../../../static/img/icon-open-menu.svg';
import { Categories, Actions, Labels } from '../../../../types/gtm';
import { useAuth } from '../../../../hooks/useAuth';
import Action from '../../../../components/Section/Action';

const BoxDeleteAccount = () => {
  const { user } = useAuth();
  const title = 'Excluir conta';
  const describeTitle = 'Exclua permanentemente sua Conta Globo e seus dados';
  return (
    <Box title={title} describeTitle={describeTitle}>
      <Content>
        <Action
          onClick={() => {
            window.dataLayer.push({
              event: 'customEventUserInteraction',
              event_category: Categories.Home,
              event_action: Actions.ClickDeleteAccount,
              event_label: Labels.Home,
              bd_suser_code: user?.globoId,
            });
          }}
          to="/excluir-conta"
          theme="link"
        >
          <p>Excluir Conta Globo</p>
          <Icon svg={svg} alt="icon-open-menu" />
        </Action>
      </Content>
    </Box>
  );
};

export default BoxDeleteAccount;
